import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Loader } from "@circle-react-shared/uikit/Loader";

interface ImagePickerImageProps {
  imgClassNames?: string;
  imgWrapperClassName?: string;
  isLoading: boolean;
  url: string;
}

export const ImagePickerImage = ({
  url,
  isLoading,
  imgClassNames = "",
  imgWrapperClassName,
}: ImagePickerImageProps) => (
  <div
    className={classNames(
      "relative m-3 flex size-[calc(100%-1.5rem)] items-center justify-center overflow-hidden rounded-lg",
      imgWrapperClassName,
    )}
  >
    {isLoading && (
      <div className="absolute z-10 flex size-full flex-col items-center justify-center">
        <Loader />
      </div>
    )}

    <img
      loading="lazy"
      src={url}
      alt=""
      className={classNames(
        "size-full rounded-lg object-contain",
        {
          "blur-xl": isLoading,
        },
        imgClassNames,
      )}
    />
  </div>
);
